/* Lemuria — výber veľkosti sviečok (candles only) — v3, odolné voči prekresleniu (morph/hydration)
 * - žiadny predvybratý variant; cena "od X €", kúpa uzamknutá, hint
 * - po výbere: cena = konkrétna suma; karty S/M/L/XL vľavo + cena vpravo
 * Všetko sa priebežne re-aplikuje cez MutationObserver, lebo Horizon PDP sekciu prekresľuje.
 */
(function () {
  if (window.__lemVReq3) return;
  window.__lemVReq3 = true;

  var LET = {
    'Malá úzka': 'S',
    'Stredná menšia široká': 'M',
    'Stredná vyššia špic': 'L',
    'Veľká': 'XL'
  };

  function readData() {
    var el = document.getElementById('lem-variant-required-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var D = readData();
  var BY = (D && D.byId) || {};
  var MIN = (D && D.minPriceFormatted) || '';

  var chosen = false;
  var lastId = null;

  function pickerEl() {
    return document.querySelector('variant-picker[data-template-product-match="true"]') ||
           document.querySelector('variant-picker');
  }
  function nativePriceEl() {
    var els = document.querySelectorAll('product-price');
    for (var i = 0; i < els.length; i++) {
      if (!els[i].closest('product-recommendations-component') &&
          !els[i].closest('product-recommendations') &&
          !els[i].closest('slideshow-slide') &&
          !els[i].closest('[data-testid="media-gallery-grid"]')) {
        return els[i];
      }
    }
    return els[0] || null;
  }
  function letterFromText(t) {
    if (!t) return '';
    var name = t.split('·')[0].replace(/\s+/g, ' ').trim();
    return LET[name] || '';
  }

  function setPrice(html) {
    var np = nativePriceEl();
    if (!np) return;
    // re-aplikuj len ak Horizon prekreslil (chýba náš marker) alebo sa obsah zmenil
    if (np.getAttribute('data-lem-html') === html && np.innerHTML.indexOf('lem-') > -1) return;
    np.setAttribute('data-lem-html', html);
    np.innerHTML = html;
  }
  function renderPrice() {
    if (!chosen) {
      setPrice('<span class="lem-fromprice"><span class="lem-fromprice__label">od</span> ' + MIN + '</span>');
    } else if (lastId && BY[lastId] && BY[lastId].price) {
      setPrice('<span class="lem-price__val">' + BY[lastId].price + '</span>');
    }
  }

  function showHint(picker) {
    if (chosen) return;
    if (picker.parentNode.querySelector('.lem-choose-hint')) return;
    var h = document.createElement('div');
    h.className = 'lem-choose-hint';
    h.setAttribute('role', 'status');
    h.textContent = 'Najprv vyberte veľkosť';
    picker.parentNode.insertBefore(h, picker.nextSibling);
  }
  function removeHint() {
    var h = document.querySelector('.lem-choose-hint');
    if (h) h.remove();
  }

  function enhance() {
    var picker = pickerEl();
    if (!picker) return;
    var radios = picker.querySelectorAll('input[type="radio"]');
    if (!radios.length) return;

    radios.forEach(function (r) {
      var label = r.closest('.variant-option__button-label');
      if (!label) return;
      label.classList.add('lem-card');
      // odznak S/M/L/XL
      if (!label.querySelector('.lem-var-letter')) {
        var textEl = label.querySelector('.variant-option__button-label__text');
        var letter = letterFromText(textEl ? textEl.textContent : (label.textContent || ''));
        if (letter) {
          var b = document.createElement('span');
          b.className = 'lem-var-letter';
          b.textContent = letter;
          label.insertBefore(b, label.firstChild);
        }
      }
      // cena vpravo
      if (!label.querySelector('.lem-var-price')) {
        var id = r.dataset.variantId;
        var info = id ? BY[id] : null;
        if (info && info.price) {
          var pr = document.createElement('span');
          pr.className = 'lem-var-price';
          pr.innerHTML = info.price;
          label.appendChild(pr);
        }
      }
    });

    if (!chosen) {
      radios.forEach(function (r) { if (r.checked) r.checked = false; });
      picker.classList.add('lem-unselected');
      document.body.classList.add('lem-size-unselected');
      showHint(picker);
    }
    renderPrice();
  }

  function onSelect(id) {
    if (id) lastId = id;
    chosen = true;
    var picker = pickerEl();
    if (picker) picker.classList.remove('lem-unselected');
    document.body.classList.remove('lem-size-unselected');
    removeHint();
    renderPrice();
  }

  // Delegované listenery (prežijú prekreslenie)
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('variant-picker input[type="radio"]') && t.checked) {
      onSelect(t.dataset.variantId);
    }
  });
  document.addEventListener('click', function (e) {
    var label = e.target && e.target.closest ? e.target.closest('.variant-option__button-label') : null;
    if (!label) return;
    var r = label.querySelector('input[type="radio"]');
    if (r) setTimeout(function () { onSelect(r.dataset.variantId); }, 0);
  });

  function boot() {
    // odstráň ?variant z URL
    try {
      var u = new URL(location.href);
      if (u.searchParams.has('variant')) { u.searchParams.delete('variant'); history.replaceState({}, '', u); }
    } catch (e) {}

    enhance();
    [30, 120, 300, 700, 1400].forEach(function (d) { setTimeout(enhance, d); });

    // Re-aplikuj po každom prekreslení (debounce)
    var to = null;
    var mo = new MutationObserver(function () {
      if (to) return;
      to = setTimeout(function () { to = null; enhance(); }, 60);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
